import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const gmpPostResubmitWorkflow = createApi(`GMPResubmitWorkflowSlice`,"POST");

const GMPResubmitWorkflowSlice = createSlice({
  name: 'GMPResubmitWorkflowSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(gmpPostResubmitWorkflow.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(gmpPostResubmitWorkflow.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(gmpPostResubmitWorkflow.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GMPResubmitWorkflowSlice.reducer;